import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toggleSideBar } from 'store/redux/sidebar'
import { IoPersonCircleOutline } from 'react-icons/io5'
interface IHeaderProps {
    title: string
}
// Android main_toolbar.xml: 56dp bar, bg colorPrimaryLight #E6F3DD,
// centered 20sp bold green title, green + on the LEFT, green avatar
// (drawer trigger) on the RIGHT.
export default function Header({ title }: IHeaderProps) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    return (
        <>
            <div className="bg-[#E6F3DD] w-full px-3 h-14 flex items-center justify-between sticky top-0 z-20">
                <button
                    aria-label="منو"
                    onClick={() => dispatch(toggleSideBar({ isOpen: true }))}
                    className="w-10 h-10 flex items-center justify-center text-green-1 active:scale-90"
                >
                    <IoPersonCircleOutline className="w-7 h-7" />
                </button>
                <p className="text-green-1 text-[20px] font-bold tracking-tight">
                    {title}
                </p>
                <button
                    aria-label="ساخت صندوق"
                    className="w-10 h-10 flex items-center justify-center text-green-1 text-3xl leading-none active:scale-90"
                    onClick={() => navigate('/add-box/moneyPool')}
                >
                    +
                </button>
            </div>
        </>
    )
}
